module.exports = __webpack_public_path__ + "img/4image-2.76e46289.png";